module.exports = __webpack_public_path__ + "static/media/estimate.5cef8cad.svg";